<template>
  <div class="page-container">
    <div class="content-container">
      <div class="user-agreement-content" v-html="processedHtml"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';

const rawHtml = ref('');

const processedHtml = computed(() => {
  if (!rawHtml.value) return '';
  
  // 创建一个临时的 DOM 解析器
  const parser = new DOMParser();
  const doc = parser.parseFromString(rawHtml.value, 'text/html');
  
  // 提取 body 中的内容
  const content = doc.body.innerHTML;
  
  return content;
});

onMounted(async () => {
  try {
    const response = await fetch('/user_agreement.html');
    rawHtml.value = await response.text();
  } catch (error) {
    console.error('Failed to load user agreement:', error);
    rawHtml.value = '<p>Failed to load user agreement.</p>';
  }
});
</script>

<style scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.user-agreement-content {
  background: #fff;
  border-radius: 8px;
}

.user-agreement-content :deep(*) {
  max-width: 100%;
  box-sizing: border-box;
}

/* Reset styles for loaded content */
.user-agreement-content :deep(body),
.user-agreement-content :deep(html) {
  all: unset;
  display: block;
}

/* Preserve text styles */
.user-agreement-content :deep(h1),
.user-agreement-content :deep(h2),
.user-agreement-content :deep(h3),
.user-agreement-content :deep(h4),
.user-agreement-content :deep(h5),
.user-agreement-content :deep(h6) {
  color: #333;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-weight: bold;
}

.user-agreement-content :deep(h1) { font-size: 2em; }
.user-agreement-content :deep(h2) { font-size: 1.5em; }
.user-agreement-content :deep(h3) { font-size: 1.17em; }
.user-agreement-content :deep(h4) { font-size: 1em; }
.user-agreement-content :deep(h5) { font-size: 0.83em; }
.user-agreement-content :deep(h6) { font-size: 0.67em; }

.user-agreement-content :deep(p) {
  color: #666;
  line-height: 1.6;
  margin: 1em 0;
}

/* 确保内容区域的样式不会被覆盖 */
.user-agreement-content {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
</style> 